import React from 'react';
import classNames from 'classnames';
import rocketImage from '../../assets/rocket.png';
import css from './ListingPage.module.css';

/**
 * The PromoteIcon component.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @returns {JSX.Element} Promote icon component
 */
const PromoteIcon = props => {
  const { className } = props;
  const classes = classNames(css.promoteIcon, className);
  return <img src={rocketImage} alt="Promote" className={classes} />;
};

export default PromoteIcon;
